export default __webpack_public_path__ + "static/media/search-icon.87e5c9f1.svg";